export const minimumCreditLimitRange = {
    min: 200,
    max: 6000,
} as const
